import React, { useEffect, useState } from 'react';
import api from '../lib/api';

const CORE_PAGES = [
  { path: '/', label: 'Tableau de bord' },
  { path: '/properties', label: 'Biens' },
  { path: '/clients', label: 'Clients' },
  { path: '/transactions', label: 'Transactions' },
];
const TENANT_TABS = [
  ['overview', 'Accueil'], ['payment', 'Payer mon loyer'], ['receipts', 'Mes quittances'], ['deposits', 'Ma caution'],
  ['notices', 'Avis et courriers'], ['requests', 'Mes demandes'], ['contract', 'Mon contrat'], ['anomalies', 'Signaler un problème'],
  ['keys', 'Mes clés'], ['inspections', 'États des lieux'], ['repairs', 'Réparations'],
];
const OWNER_TABS = [
  ['properties', 'Mes biens'], ['tenants', 'Mes locataires'], ['documents', 'Documents'], ['visits', 'Visites'],
  ['maintenance', 'Entretien'], ['withdrawals', 'Retraits'], ['financial', 'Relevés'],
];
const sel = 'mt-1 w-full rounded-xl border border-gray-200 px-3 py-2 text-sm bg-white';

export const EMPTY_LINK = { link_type: 'none', link_target: '', link_label: '', tenant_tab: '', owner_tab: '' };

export const AnnouncementLinkFields = ({ value, onChange, audience }) => {
  const [pages, setPages] = useState(CORE_PAGES);
  const [props, setProps] = useState([]);
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });

  useEffect(() => {
    api.get('/access/catalog').then((r) => setPages([...CORE_PAGES, ...(r.data || []).map((m) => ({ path: m.path, label: m.label }))])).catch(() => {});
  }, []);
  useEffect(() => {
    if (value.link_type === 'property' && !props.length) {
      api.get('/properties').then((r) => setProps(r.data || [])).catch(() => {});
    }
  }, [value.link_type, props.length]);

  return (
    <div className="space-y-2 rounded-xl border border-dashed border-[#B85C38]/30 bg-white/70 p-3" data-testid="announcement-link-fields">
      <label className="block text-xs font-semibold text-gray-600">Rendre le message cliquable
        <select value={value.link_type} onChange={(e) => onChange({ ...value, link_type: e.target.value, link_target: '' })} className={sel} data-testid="announcement-link-type">
          <option value="none">Non, pas de lien</option>
          <option value="page">Vers une page de l'application</option>
          <option value="property">Vers un bien précis</option>
          <option value="external">Vers un site externe</option>
        </select>
      </label>
      {value.link_type === 'page' && (
        <select value={value.link_target} onChange={set('link_target')} className={sel} data-testid="announcement-link-page">
          <option value="">— Choisir la page —</option>
          {pages.map((p) => <option key={p.path} value={p.path}>{p.label}</option>)}
        </select>
      )}
      {value.link_type === 'property' && (
        <select value={value.link_target} onChange={set('link_target')} className={sel} data-testid="announcement-link-property">
          <option value="">— Choisir le bien —</option>
          {props.map((p) => <option key={p.id} value={p.id}>{p.property_code ? `${p.property_code} · ` : ''}{p.title}</option>)}
        </select>
      )}
      {value.link_type === 'external' && (
        <input value={value.link_target} onChange={set('link_target')} placeholder="https://…" className={sel} data-testid="announcement-link-url" />
      )}
      {value.link_type !== 'none' && (
        <input value={value.link_label} onChange={set('link_label')} maxLength={40} placeholder="Texte du bouton (ex : Voir les impayés)" className={sel} data-testid="announcement-link-label" />
      )}
      {audience === 'all' && (
        <div className="grid grid-cols-2 gap-2 pt-1">
          <label className="text-xs font-semibold text-gray-600">Lien pour les locataires
            <select value={value.tenant_tab} onChange={set('tenant_tab')} className={sel} data-testid="announcement-link-tenant-tab">
              <option value="">Aucun</option>
              {TENANT_TABS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
            </select>
          </label>
          <label className="text-xs font-semibold text-gray-600">Lien pour les propriétaires
            <select value={value.owner_tab} onChange={set('owner_tab')} className={sel} data-testid="announcement-link-owner-tab">
              <option value="">Aucun</option>
              {OWNER_TABS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
            </select>
          </label>
        </div>
      )}
    </div>
  );
};
